// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HealthInsightsPage from "../pages/HealthInsights/HealthInsights";
const __wvcRoutePaths = ["/HealthInsightsPage", "/health-insights"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-bodywerks", "aboutbodywerkspage", "bodywerks-blog-listing-page", "bodywerksbloglistingpagepage", "book-an-appointment-bodywerks-chiropractic-limassol-nicosia", "bookappointmentpage", "chiropractor-in-limassol", "chiropractor-in-nicosia-cyprus-bodywerks-nicosia-clinic", "chiropractorinlimassolpage", "chiropractornicosiaclinicpage", "condition-treatment", "conditions", "conditionspage", "conditiontreatmentpage", "contact", "contactpage", "free-online-posture-assessment", "freeonlinepostureassessmentpage", "health-insights", "healthinsightspage", "home", "homepage", "our-story", "ourstorypage", "post", "sciatica-offer", "sciaticaofferpage", "servicenameinlimassolnicosiacypruspage", "the-back-pain-blueprint", "treatments", "treatmentspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<HealthInsightsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<HealthInsightsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
